import { SubmitApplicationResult } from '@servicetitan/financing-api-client';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface DecisionData extends SubmitApplicationResult {
    /** URL to redirect to when application is declined */
    declineRedirectUrl?: string | null;
    /**
     * Provider-hosted URL the applicant should continue on. Kept separate from declineRedirectUrl
     * so decline and continue-application flows never share state.
     */
    redirectUrl?: string | null;
    /**
     * True once the second-look provider has also declined the applicant, so both the first-look
     * and second-look outcomes are terminal declines. A second-look poll that reaches its ceiling
     * without a decision counts as a decline, matching how the workflows already treat a timeout.
     */
    secondLookDeclined?: boolean;
}

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __IS_DECISION_DATA_STORE_CREATED?: boolean;
        DecisionDataStore?: any;
    }
}

function useDecisionData(initialState: DecisionData) {
    const [decisionData, setDecisionData] = useState(initialState);

    return { decisionData, setDecisionData };
}

// if (!window.__IS_DECISION_DATA_STORE_CREATED) {
export const DecisionDataStore = createStore(useDecisionData);
// window.__IS_DECISION_DATA_STORE_CREATED = true;
// }

// export const DecisionDataStore = window.DecisionDataStore;

export type DecisionDataStore = ReturnType<typeof useDecisionData>;
